import React from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import { useFormikContext } from 'formik';
import {CheckboxWithLabel} from './FormFields';

export default function SubmitTabBody(props) {

	const labels = {
		"home.submit.certification.allInformationIsTrueAndComplete"   : useIntl().formatMessage({id:"home.submit.certification.allInformationIsTrueAndComplete"})
		, "home.submit.certification.newAppealCommunicationAgreement" : useIntl().formatMessage({id:"home.submit.certification.newAppealCommunicationAgreement"})
		, "sima.submit.checkbox.1" : useIntl().formatMessage({id:"sima.submit.checkbox.1"}, {i: (chunks) => <i>{chunks}</i>})
		, "sima.submit.checkbox.2" : useIntl().formatMessage({id:"sima.submit.checkbox.2"}, {strong: (chunks) => <strong>{chunks}</strong>}) //Lookup formatMessage chunks thing
	}

	const { errors } = useFormikContext();

	return (
		<>
			<div className="form-group col-md-12 text-left row-magic">
				<h2><FormattedMessage id="home.submit.certification.title" /></h2>
				<div className="form-group col-md-12 text-left" id="certificationField">
					<CheckboxWithLabel name="certificationField" required={true}
						options={[
							{value:"yes", required:true, label:
								props.displayCorrespondenceAgreementCertificationMsg === true ?
									<>{labels["sima.submit.checkbox.1"]}<br/><br/>{labels["sima.submit.checkbox.2"]}</>
								: labels["sima.submit.checkbox.2"]
							}
						]}
					/>
				</div>
			</div>
				<>
					<div className="form-group col-md-6 text-right" style={{float:"right"}} >
						<button type="submit" id="appealFormSubmit" data-testid="button.submit" className="btn btn-primary"
							onClick={() => Object.keys(errors).length === 0 ? "" : props.setErrorFocus(true)}
						>
							<FormattedMessage id="button.submit"/>&nbsp;
							{props.displayReadOnlyWarning ? <span className="glyphicon glyphicon-chevron-right hidden-sm hidden-xs"></span> : <></>}
							{props.displayReadOnlyWarning ? <span className="glyphicon glyphicon-chevron-down hidden-md hidden-lg hidden-xl"></span> : <></>}
						</button>
					</div>
				</>

		</>
	);
}